package pwgs.ui.scenes.playerlogsscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(PlayerLogsSceneProps::class, PlayerLogsSceneModel::class)
interface PlayerLogs {
    fun load()
    fun enableLogging()
    fun disableLogging()
}

@Serializable
data class PlayerLogsSceneProps(
    val projectId: Long,
    val userId: String
)

@Serializable
class PlayerLogsSceneModel(
    val isLoggingEnabled: Boolean,
    val items: List<PlayerLogItemModel>
) {
    var isLoading = true
}

@Serializable
class PlayerLogItemModel(
    val type: String,
    val content: String,
    val createdAt: Long,
    val stackTrace: String
)